import { TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";

import { DatasetEditorContext } from "../..";

import { DropdownMenuVariant } from "@/components/ui/DropdownMenu/types";
import { useRbac } from "@/providers/RbacProvider";
import { EntityType } from "@/queries";

export const useDeleteDataset = ({
  setIsDiscarded,
}: {
  setIsDiscarded: (value: boolean) => void;
}) => {
  const context = useContext(DatasetEditorContext);

  const handleOnDeleteClick = () => {
    setIsDiscarded(true);
    context?.handleDeleteClick?.();
  };

  const { isDeleteDisabled } = useRbac();
  const cannotDeleteDataset = isDeleteDisabled(EntityType.DATASET);

  return {
    id: "delete-dataset",
    label: "Discard Draft",
    icon: TrashIcon,
    onClick: handleOnDeleteClick,
    tooltipContent: cannotDeleteDataset
      ? "You don't have permission to delete this dataset"
      : undefined,
    getDisabled: () =>
      cannotDeleteDataset ||
      context?.isSavingDataset ||
      context?.isDeletingDataset ||
      context?.isDeletingDatasetGroup ||
      !context?.isDraft,
    shouldShow: context?.isDraft && !context?.isSavingDataset,
    isLoading: context?.isDeletingDataset || context?.isDeletingDatasetGroup,
    variant: DropdownMenuVariant.DESTRUCTIVE,
  };
};
